import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { MdLocationPin } from "react-icons/md";
import { STR_GRANT_LOCATION_ACCESS, STR_TURN_ON_LOCATION, STR_YOUR_CURRENT_LOCATION, STR_YOUR_LOCATION_LOADING } from "../Strings";
import MobileInterface from "../MobileInterface";


export default function UserLocationPin(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);


  async function init() {
    //run initializations here
    setReady(false);
    //..
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    return (
      <div className="card bg-surface mShadow4">
        <div className="card-body">
					
          <div className="d-flex justify-content-between">

						<h6
							style={{
								fontSize: "12px"
							}}
							className="font-bold text-primary align-self-center"
						>
							{STR_YOUR_CURRENT_LOCATION[appContext.language]}
						</h6>

            <MdLocationPin
              size={40}
              style={{
                flexShrink: "0",
              }}
              className="text-primary align-self-center"
            />
            
          </div>

					<div
						style={{
							padding: "5px",
						}}
						className=""
					>
						{
							(
								appContext.currentLocation &&
								appContext.currentLocation.lat &&
								appContext.currentLocation.lng
							) ?
								<h6
									style={{
										fontSize: "16px",
									}}
									className="mNoMargin"
								>
									{appContext.currentLocationString}
									<br />
									<span style={{ fontSize: "12px", }}>Lat: {appContext.currentLocation.lat}</span>,
									<span style={{ fontSize: "12px", }}>Lng: {appContext.currentLocation.lng}</span>
								</h6>
								:
								<h6
									style={{
										fontSize: "12px",
									}}
									className="mNoMargin"
								>
									{STR_YOUR_LOCATION_LOADING[appContext.language]}
								</h6>
						}


					</div>

          <div className="text-start">
            {
              (!appContext.isLocationPermissionGranted && appContext.clientPlatformType !== 'web') ?
                <button
                  className="btn btn-sm btn-dark m-1 mt-4 btn-rounded"
                  style={{
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    MobileInterface.requestLocationPermission();
                  }}
                >
                  {STR_GRANT_LOCATION_ACCESS[appContext.language]}
                </button>
                : ""
            }

            {
              (!appContext.isLocationSwitchOn && appContext.clientPlatformType !== 'web') ?
                <button
                  className="btn btn-sm btn-dark m-1 mt-4 btn-rounded"
                  style={{
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    MobileInterface.showLocationSettingsAlert();
                  }}
                >
                  {STR_TURN_ON_LOCATION[appContext.language]}
                </button>
                : ""
            }
          </div>

        </div>
      </div>
    )
  } else {
    return (
      <div
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }


}